import React from 'react';
import { Link } from 'react-router-dom';
import "./topbar.css"
function TopBar() {
    const user=false;
    return (
      
        <div class="top">
            <div className="topLeft">
            <i className=" topIcon fab fa-facebook-square"></i>
            <i className="topIcon fab fa-twitter-square"></i>
            <i className=" topIcon fab fa-pinterest-square"></i>
            </div>
            <div className="topCenter">
                <ul className="toplist">
                    <li className="toplistItem">
                       <Link className="link" to="/" >HOME</Link>
                       </li>
                    <li className="toplistItem">
                    <Link className="link" to="/" >ABOUT</Link>
                    </li>
                    <li className="toplistItem">
                    <Link className="link" to="/" >CONTACT</Link> </li>
                    <li className="toplistItem">
                    <Link className="link" to="/write" >WRITE</Link></li>
                    <li className="toplistItem">{user && "LOGOUT"}</li>
                </ul>
            </div>
            <div className="topRight">
                {user? (<img className="avatar"src="https://images.pexels.com/photos/1167355/pexels-photo-1167355.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=94" alt=""/>)
                :(
                    <ul className="toplist">
                    <li className="toplistItem">
                      <Link className="link" to="/login">
                        LOGIN
                      </Link>
                    </li>
                    <li className="toplistItem">
                      <Link className="link" to="/register">
                        REGISTER
                      </Link>
                    </li>
                  </ul>
                )
}
               
               <i class="topSearchICon fas fa-search"></i>
            </div>
        </div>
    )
}

export default TopBar
